import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import {
  AiFillGithub,
  AiOutlineTwitter,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              Hello! I'm a <b className="purple">Cloud & DevOps Engineer</b> at{" "}
              <b className="purple">Unloq®</b>, building AI infrastructure and strategic 
              intelligence platforms. Currently pursuing M.Tech in{" "}
              <b className="purple">Cloud Computing</b> at IIT Patna.
              <br />
              <br />
              I specialize in building <b className="purple">cloud-native applications</b> and{" "}
              <b className="purple">DevSecOps pipelines</b>—from designing CI/CD workflows with{" "}
              <i>
                <b className="purple">Jenkins and GitHub Actions</b>
              </i>, to containerizing apps with{" "}
              <i>
                <b className="purple">Docker and Kubernetes</b>
              </i>, to provisioning secure infrastructure on{" "}
              <i>
                <b className="purple">AWS (EC2, S3, RDS, Lambda, VPC)</b>
              </i>.
              <br />
              <br />
              I've built production-ready projects including a{" "}
              <b className="purple">Docker Security Scanner</b> that eliminates 91% of 
              vulnerabilities, an <b className="purple">AWS Cost Analyzer</b> that identified 
              $1,530 in yearly savings, a <b className="purple">Terraform Drift Detector</b>{" "}
              with auto-fix generation, and <b className="purple">automated CI/CD pipelines</b>{" "}
              reducing deployment time by 95%.
              <br />
              <br />
              My work combines <b className="purple">infrastructure automation</b>,{" "}
              <b className="purple">container orchestration</b>, and{" "}
              <b className="purple">cloud security</b> to build scalable, reliable systems 
              that solve real-world problems. I'm passionate about DevOps best practices, 
              Infrastructure as Code, and continuous improvement.
              <br />
              <br />
              🏆 <b className="purple">Rising Star Award 2025 (MIECA)</b> |{" "}
              🏅 <b className="purple">Top 10 - Agent.ai Hackathon 2024</b> |{" "}
              🛰️ <b className="purple">Ex-ISRO Research Intern</b>
            </p>
          </Col>

          <Col md={4} className="myAvtar">
            <img src={myImg} className="img-fluid" alt="avatar" />
          </Col>
        </Row>

        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/sourav8908"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>

              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/sourav89/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>

              <li className="social-icons">
                <a
                  href="https://x.com/SouravMohan98"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiOutlineTwitter />
                </a>
              </li>

              <li className="social-icons">
                <a
                  href="https://www.hackerrank.com/profile/mohantysourav537"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                  title="HackerRank"
                >
                  {/* Custom HackerRank SVG icon */}
                  <svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" viewBox="0 0 50 50" fill="currentColor">
                    <g>
                      <polygon fill="#2EC866" points="25,2 47,13 47,37 25,48 3,37 3,13"/>
                      <path fill="#fff" d="M34.2,32.7h-3.2l-2.7-4.7h-4.6v4.7h-3.1V17.3h8.2c3.1,0,5.1,1.7,5.1,4.6c0,2.1-1,3.5-2.8,4.2l3,5.2
                        C34.9,32.1,34.7,32.7,34.2,32.7z M29.2,22.2c1.4,0,2.1-0.6,2.1-1.8c0-1.2-0.7-1.8-2.1-1.8h-4.5v3.6H29.2z"/>
                    </g>
                  </svg>
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
